import React from 'react'
import './Footer.css'
import lapianaLogo from '../../../images/lapiana_transparent.png'

const Footer = () => {
	return (
		<div style={{ backgroundColor: '#89292a' }}>
			<footer>
				<div>
					<div className='row'>
						<div className='col text-center'>
							{/* <h1
								className='font-weight-light text-capitalize p-3'
								style={{ color: 'white' }}
							>
								AHA Badgers - Lapiana
							</h1> */}
							<div>
								<img src={lapianaLogo} className='sssLogo' />
							</div>
							<h4
								className='font-weight-bold font-italic'
								style={{ color: 'white', fontSize: 'small' }}
							>
								We didn't come this far just to come this far...
							</h4>
							<div className='py-3'>
								<a
									href='https://www.facebook.com/AHABadgers'
									target='_blank'
									style={{ color: 'white' }}
								>
									<i className='fab fa-facebook fa-3x mx-3'></i>
								</a>
							</div>
							<p
								className='py-4 m-0 copyright'
								style={{ color: 'white', backgroundColor: '#686868' }}
							>
								A Web Application by{' '}
								<a
									href='https://www.shireystatsandstandings.com/#'
									target='_blank'
									style={{ color: 'white' }}
								>
									Shirey Stats and Standings, LLC
								</a>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
